function getColor(classes, matchingString) {
	let color; // default?
	$.each(classes, function(index, item) {
		if (item.match(matchingString)) {
			// eslint-disable-next-line prefer-destructuring
			color = item.split('-')[1];
		}
	});
	return color;
}

$(() => {
	$(document).ready(function() {
		const hex = $('.flowchart-hex');
		if (hex.length) {
			const accordionHeader = $('.js-accordion-header');
			const accordionItem = $('.js-accordion-item');
			const hexActiveClass = 'hex-active';
			const accordionActiveClass = 'active';
			const accordionPrefix = 'color-';
			const hexPrefix = 'hex-';
			const matchingString = 'color';

			const activeAccordionItem = accordionItem.filter('.' + accordionActiveClass);
			const activeAccordionItemClasses = activeAccordionItem.attr('class').split(/\s+/);
			const starterColor = getColor(activeAccordionItemClasses, matchingString);
			hex.removeClass(hexActiveClass);
			$('.' + hexPrefix + starterColor).addClass(hexActiveClass);

			hex.click(function () {
				const hexId = $(this).attr('id');
				const accordionSelector = accordionPrefix + hexId;
				const thisHex = $(this);

				hex.not(thisHex).removeClass(hexActiveClass);
				// thisHex.toggleClass(hexActiveClass);
				if (thisHex.hasClass(hexActiveClass)) {
					thisHex.removeClass(hexActiveClass);
				} else {
					thisHex.addClass(hexActiveClass);
				}

				$('.' + accordionSelector).find(accordionHeader).click();
			});

			accordionHeader.click(function() {
				const parentClasses = $(this).parent().attr('class').split(/\s+/);
				hex.removeClass(hexActiveClass);
				if ($(this).parent().hasClass(accordionActiveClass)) {
					const color = getColor(parentClasses, matchingString);
					$('.' + hexPrefix + color).addClass(hexActiveClass);
				}
			});
		}
	});
});



// WEBPACK FOOTER //
// ./assets/scripts/flowchart.js